import React from "react";
import styles from "./Cards.module.css";
import home from "../img/html.png";
import contact from "../img/javascript.png";
import sale1 from "../img/react.png";
import about from "../img/github.png";
import MainNav from "../components/MainNav";

const Welcome = () => {
  return (
    <div className={styles.cardContainer}>
      <MainNav />
      <ul className={styles.listItems}>
        <li>
          <div className={styles.extra}></div>
          <img className={styles.star} src={home} alt="" />
          <a className={styles.link} href="#nowhere">
            HTML5&CSS3
          </a>
          <span>
            -learned how to use the latest sintax in HTML5 and CSS3 in order to
            achieve modern websites and beatiful UI
            <br />
            -CSS Grid and Flexbox Layout Modules.
            <br />
            -Responsive Design
            <br />
            -SEO Optimization
            <br />
          </span>
          <div className={styles.bottom}>#frontend #seo #optimization</div>
        </li>
        <li>
          <div className={styles.extra}></div>
          <img className={styles.star} src={contact} alt="" />

          <a className={styles.link} href="#nowhere">
            JavaScript
          </a>
          <span>
            -Learned about the JavaScript fundamentals: variables, if/else,
            operators, boolean logic, functions, arrays, objects, loops,
            strings, and more <br></br>
            -Learned modern JavaScript (ES6+) from the beginning: arrow
            functions, destructuring, spread operator, default arguments,
            optional chaining (ES2020<br></br>
            -How JavaScript works behind the scenes: the call stack, hoisting,
            scoping, the 'this' keyword.
            <br></br>
            -OOP: prototypal inheritance, constructor functions (ES5), classes
            (ES6)<br></br>
          </span>
          <div className={styles.bottom}>#interactive #javascript</div>
        </li>

        <li>
          <div className={styles.extra}></div>
          <img className={styles.star} src={sale1} alt="" />

          <a className={styles.link} href="#nowhere">
            React
          </a>
          <span>
            -Components, props & dynamic data binding <br />
            -Working with user events and state to create interactive
            applications
            <br />
            -React Hooks
            <br />
            -Styling React apps with "Styled Components" and "CSS Modules"
            <br />
            -Sending Http requests & handling transitional states + responses
            <br />
            -Handling forms and user input (incl. validation)
            <br />
            -Redux & Redux Toolkit
            <br />
            -Routing with React Router
            <br />
          </span>
          <div className={styles.bottom}>#framework #react hooks</div>
        </li>
        <li>
          <div className={styles.extra}></div>
          <img className={styles.star} src={about} alt="" />

          <a className={styles.link} href="#nowhere">
            ... and
          </a>
          <span>
            - Besides the basics languages that a frontend developer need i also
            have worked with ExpressJS , NodeJS , MOngoDb , Firebase with
            Firestore and Auth , MOngoose , Git , GitHub <br />- i worked with
            different frameworks such as Materialize , animate on scroll ,
            ThreeJS and React Three Fiber. With ThreeJS i only have basic
            knowledge but i am interested in learning more about it.
          </span>
          <div className={styles.bottom}>#library #framework #backend</div>
        </li>
      </ul>
      <h1 className={styles.menuText}>
        <span>M</span>
        <span>A</span>
        <span>I</span>
        <span>N</span>
        <span>&nbsp;</span>
        <span>T</span>
        <span>E</span>
        <span>C</span>
        <span>H</span>
      </h1>
    </div>
  );
};

export default Welcome;
